import Slot from '@dreryk/watermelon/target/javascript/Slot';
import { useAsyncFn } from 'react-use';

import {
   StatisticsData,
   StatisticsDataQuery,
   StatisticsOrder,
   StatisticsOrderQuery,
} from '@dreryk/egabinet-statistics-frontend-api';

import { CqrsQueryPerformResult, performCqrsQueryFind } from '@dreryk/command-query-react-common';

import { printStatistics } from './printFrame';

const findStatisticsData = async (statisticsId: number): CqrsQueryPerformResult<StatisticsData | null> =>
   performCqrsQueryFind<StatisticsData>(
      () => {
         const query = new StatisticsDataQuery();
         query.id = statisticsId;
         return query;
      },
      {
         cacheTime: 'long',
      }
   );

const findStatisticsOrder = async (statisticsId: number): CqrsQueryPerformResult<StatisticsOrder | null> =>
   performCqrsQueryFind<StatisticsOrder>(
      () => {
         const query = new StatisticsOrderQuery();
         query.id = Slot.of(statisticsId);
         return query;
      },
      {
         cacheTime: 'long',
      }
   );

type usePrintType = {
   isLoading: boolean;
   onPrint: VoidFunction;
};

export const usePrint = (statisticsId: number): usePrintType => {
   const [state, handlePrint] = useAsyncFn(async () => {
      const [statisticsOrder, statisticsData] = await Promise.all([
         findStatisticsOrder(statisticsId),
         findStatisticsData(statisticsId),
      ]);
      if (!statisticsData || !statisticsOrder) {
         return;
      }
      printStatistics(statisticsOrder, statisticsData);
   }, []);

   return { isLoading: state.loading, onPrint: handlePrint };
};
